export default __webpack_public_path__ + "static/media/Litto-5.d34ad1b8.png";